const i = {
  code: "vi",
  facebook: "vi_VN",
  label: "Tiếng việt",
  loadingText: "Tải...",
  translations: {
    ar: "Tiếng Ả rập",
    de: "Tiếng Đức",
    en: "Tiếng Anh",
    es: "Tiếng Tây Ban Nha",
    fr: "Tiếng Pháp",
    he: "Tiếng Do Thái",
    hi: "Tiếng Hindi",
    id: "Tiếng Indonesia",
    it: "Tiếng Ý",
    ja: "Tiếng Nhật",
    km: "Tiếng Khmer",
    ko: "Tiếng Hàn",
    lo: "Tiếng Lào",
    ms: "Tiếng Malay",
    nl: "Tiếng Hà Lan",
    pt: "Tiếng Bồ Đào Nha",
    ru: "Tiếng Nga",
    th: "Tiếng Thái Lan",
    tl: "Tiếng Filipino",
    tr: "Tiếng Thổ Nhĩ Kỳ",
    vi: "Tiếng Việt",
    "zh-CN": "Tiếng Trung (Giản thể)",
    "zh-TW": "Tiếng Trung (Phồn thể)"
  }
};
export {
  i as vietnamese
};
